export const CONNECTED_ACCOUNT_SERVER_HINT_COOKIE_NAME =
  "connected-account-server-hint"
